import React, { memo, useCallback, useEffect } from "react";

import Box from "@mui/material/Box";
import List from "@mui/material/List";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import line from "../../assents/img/Line.png";
import StopCard from "../StopCard";

const Wrapper = styled(Box)(({ theme }) => ({
  width: "335px",
  marginTop: "30px",
  marginLeft: "auto",
  marginRight: "auto",
  textAlign: "center",
  boxSizing: "border-box",
  [theme.breakpoints.up("sm")]: {
    width: "100%",
    marginTop: "39px",
    marginLeft: 0,
    marginRight: 0,
  },
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  fontFamily: "Rubik",
  fontWeight: 500,
  fontSize: "29px",
  lineHeight: 1.4,
  color: "#1a1a1a",
  [theme.breakpoints.up("sm")]: {
    fontSize: "30px",
  },
}));

const SectionSubTitle = styled(Typography)(() => ({
  fontFamily: "Rubik",
  fontWeight: 300,
  fontSize: "20px",
  lineHeight: 1.4,
  color: "#1a1a1a",
  marginBottom: "12px",
}));

const StopsList = styled(List)(({ theme }) => ({
  padding: "20px 0 0 0",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  backgroundImage: `url(${line})`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "top center",
  boxSizing: "border-box",
  [theme.breakpoints.up("sm")]: {
    padding: "58px 0 0 0",
  },
}));

const AddedStopsSection = memo(
  ({
    setMobileButtonsVisible,
    isMobile,
    addClicked,
    addedStops,
    addedStopsId,
    popularStopsId,
    popularStopsCount,
    removeStation,
    total,
    tourDefaultPrice,
  }) => {
    useEffect(() => {
      if (isMobile) {
        if (addClicked){
          if (document.body.offsetWidth >= 600) {
            window.scrollTo({left:0,top: document.body.scrollHeight, behavior:'smooth'})
          } else {
            window.scrollTo({left:0,top: document.body.scrollHeight - 1250, behavior:'smooth'})
          }
        } 
      } else {
        if (addClicked) window.scrollTo({left:0,top: document.body.scrollHeight, behavior:'smooth'})
      }
    }, [addedStops])

    const throttling = useCallback(() => {
        return function throttle(func, ms) {
          let isThrottled = false,
            savedArgs,
            savedThis;
          function wrapper() {
            if (isThrottled) { // (2)
              savedArgs = arguments;
              savedThis = this;
              return;
            }
            func.apply(this, arguments); // (1)
            isThrottled = true;
            setTimeout(function() {
              isThrottled = false; // (3)
              if (savedArgs) {
                wrapper.apply(savedThis, savedArgs);
                savedArgs = savedThis = null;
              }
            }, ms);
          }
          return wrapper;
        }
    }, [])

    

      
    useEffect(() => {
      if (isMobile) {
          function checkScroll() {
        if (document.documentElement.scrollTop >= 280) {
          setMobileButtonsVisible(true)
        } else {
          setMobileButtonsVisible(false)
        }
      }
      const checkThrottle = throttling()(checkScroll, 500)
      window.addEventListener('scroll', checkThrottle)
      return () => {
        window.removeEventListener(checkThrottle)
      }
      }
    },[])
  
    
    return (
      <Wrapper>
        <SectionTitle>Start editing your tour</SectionTitle>
        <SectionSubTitle>
          {addedStopsId.join("") === popularStopsId.join("")
            ? `We have added ${popularStopsCount} popular stop${
                popularStopsId.length === 1 ? "" : "s"
              }`
            : `You have added ${addedStops.length} stop${
                addedStops.length === 1 ? "" : "s"
              } to your trip`}
        </SectionSubTitle>
        <StopsList>
          {addedStops?.map((el) => (
            <StopCard
              stop={el}
              total={total}
              tourDefaultPrice={tourDefaultPrice}
              removeStation={removeStation}
              isFromAddedStations={true}
              key={el.id}
            />
          ))}
        </StopsList>
      </Wrapper>
    );
  }
);

export default AddedStopsSection;
